import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { CurrentValueIndicator } from 'features/Dashboard/pages/components/CurrentValueIndicator';
import Header from 'features/Dashboard/pages/components/Graph/components/Header';

import { useGraphColorSchema } from '../../hooks/useGraphColorSchema';
import { DeltaIndicator } from '../DeltaIndicator';
import { EvolutionColorSchema } from './types';

export const DeltaValueHeader: FC<
  {
    currentValue?: number;
    previousValue?: number;
    title: string;
    evolutionColorSchema: EvolutionColorSchema | null;
    titleFontSize?: string;
    displayArrow?: boolean;
  } & React.ComponentProps<typeof Header>
> = ({
  currentValue,
  displayArrow = true,
  evolutionColorSchema,
  previousValue,
  title,
  titleFontSize = 'font-13',
  ...headerProps
}) => {
  const delta =
    previousValue !== undefined && currentValue !== undefined
      ? currentValue - previousValue
      : null;

  const colorSchema = useGraphColorSchema({ delta, evolutionColorSchema });

  return (
    <Header
      backgroundColor={colorSchema.bg}
      flexDirection="column"
      gap={0}
      {...headerProps}
    >
      <Flex borderBottom="none" flexDirection="column" flexGrow={1} gap={0}>
        <Text fontSize={titleFontSize || 'font-13'} variant="primary">
          {title}
        </Text>

        <CurrentValueIndicator
          arrowColors={{
            arrow: colorSchema.arrow,
            background: colorSchema.arrowBg,
            border: colorSchema.arrowBorder,
          }}
          currentValue={currentValue}
          delta={delta}
          displayArrow={displayArrow}
        />

        <DeltaIndicator delta={delta} />
      </Flex>
    </Header>
  );
};
